import React from 'react';
import { Descriptions } from 'antd';
import type { ClosingPackageTaskModalContextView } from '../../lib/taskModalContext';

export type ClosingPackageTaskModalContextProps = {
  contextView: ClosingPackageTaskModalContextView;
};

const ClosingPackageTaskModalContext: React.FC<ClosingPackageTaskModalContextProps> = ({
  contextView,
}) => (
  <Descriptions size="small" column={2} bordered style={{ marginBottom: 16 }}>
    <Descriptions.Item label="Заявка">{contextView.applicationNumber}</Descriptions.Item>
    <Descriptions.Item label="Клиент">{contextView.clientName}</Descriptions.Item>
    <Descriptions.Item label="Маршрут" span={2}>
      {contextView.routeSummary}
    </Descriptions.Item>
    <Descriptions.Item label="Комплект документов" span={2}>
      {contextView.packageSummary}
    </Descriptions.Item>
  </Descriptions>
);

export default ClosingPackageTaskModalContext;
